export class PageFilter {
    public id:number|null;
    public klg_permission_page_id:number;
    public client_permission_page_id:number;
    public name:string;

    constructor(data:PageFilterData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.klg_permission_page_id = -1;
            this.client_permission_page_id = -1;
            this.name = "";
        }
        else
        {
            this.id = data.id;
            this.klg_permission_page_id = data.klg_permission_page_id;
            this.client_permission_page_id = data.client_permission_page_id;
            this.name = data.name;
        }
    }
    public resetToDefaults():void {
        this.id = null;
        this.klg_permission_page_id = -1;
        this.client_permission_page_id = -1;
        this.name = '';
    }
}

export type PageFilterData = {
    id:number|null;
    klg_permission_page_id:number;
    client_permission_page_id:number;
    name:string;
}